import { render } from "./SetupLayout.vue?vue&type=template&id=67adfde2"
import script from "./SetupLayout.vue?vue&type=script&lang=js"
export * from "./SetupLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__